<template>
  <div v-if="currentEmpresa.prioridade_empresa">
    <v-card :loading="loading" class="mb-4 p-1" elevation="10">
      <v-card-title>
        <div class="flex justify-between items-center">
          <span class="text-lg">Empresa Prioridade</span>
          <span class="text-lg"
            >Data:
            {{ formatDateDay(currentEmpresa.prioridade_empresa.data) }}</span
          >
        </div>
        <v-btn
          v-show="!loading"
          icon
          @click="deletePrioridadeEmpresa(currentEmpresa.prioridade_empresa)"
        >
          <v-icon color="error">mdi-delete</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div class="flex flex-col space-y-2">
          <div>
            <span>Motivo : {{ currentEmpresa.prioridade_empresa.motivo }}</span>
          </div>
          <div class="flex justify-between items-center">
            <span
              class="my-3 shadow rounded p-2 text-neutral-300"
              :class="{
                'bg-success-base':
                  currentEmpresa.prioridade_empresa.activities[0]
                    .description === 'created',
                'bg-warning-base':
                  currentEmpresa.prioridade_empresa.activities[0]
                    .description === 'updated',
                'bg-erro-base':
                  currentEmpresa.prioridade_empresa.activities[0]
                    .description === 'deleted',
              }"
            >
              Descrição:
              {{
                descricaoLogsPrioridade(
                  currentEmpresa.prioridade_empresa.activities[0].description
                )
              }}
            </span>
            <span class="mr-1">
              Usuário:
              {{
                currentEmpresa.prioridade_empresa.activities[0].nome_completo
              }}
            </span>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import moment from "moment";
import { formatDateDay } from "@/utils/momentHelpers";

export default {
  props: {
    currentEmpresa: {
      type: Object,
      required: true,
    },
},
    data() {
      return {
        loading: false,
      };
    },
  
  methods: {
    formatDateDay,
    deletePrioridadeEmpresa(prioridade) {
      this.$buefy.dialog.confirm({
        title: "Confirmação",
        message: "Tem certeza que deseja excluir essa prioridade?",
        confirmText: "Sim",
        cancelText: "Cancelar",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          this.loading = true;
          this.$store
            .dispatch("prioridadeEmpresa/delete_prioridade_empresa", prioridade)
            .then(() => {
              this.$snack.success("Prioridade excluída com sucesso.");
            })
            .finally(() => {
              this.$emit("delete");
              this.loading = false;
            });
        },
      });
    },

    descricaoLogsPrioridade(description) {
      let descricao = {
        created: "Criou",
        updated: "Atualizou",
        deleted: "Deletou",
      };
      return descricao[description];
    },
  },
};
</script>